module.exports = __webpack_public_path__ + "static/media/coinBase.9ab84477.svg";